import {
    Accordion,
    AccordionItem,
    AccordionTrigger,
    AccordionContent,
} from "@/components/ui/accordion";

const FAQS = [
    {
        q: "¿De verdad no cuesta nada?",
        a: "Así es. Crear tu tienda, subir productos y recibir pedidos no tiene costo mensual ni comisión por venta. Lo único que se descuenta es la comisión del procesador de pagos por cada cobro con tarjeta, y el envío lo paga tu cliente al momento de comprar.",
    },
    {
        q: "¿Cómo recibo mi dinero?",
        a: "Tu cliente paga el total (productos más envío) al momento de la compra. Nosotros te transferimos el monto de tus productos menos la comisión del procesador de pagos, y con la parte del envío se paga la guía de la paquetería.",
    },
    {
        q: "¿Qué necesito para empezar?",
        a: "Tu correo, el nombre de tu tienda y al menos un producto con foto, precio y peso. Si vas a mandar paquetes, también la dirección desde donde envías. Nada de esto toma más de unos minutos.",
    },
    {
        q: "¿Puedo vender sin enviar paquetes?",
        a: "Sí. Puedes activar la entrega acordada con el cliente para ventas locales: el comprador paga en línea y ustedes acuerdan dónde y cuándo se entrega, sin costo de envío.",
    },
    {
        q: "¿Necesito factura o clave del SAT?",
        a: "Para generar guías de envío se pide la clave de producto del catálogo del SAT que corresponde a lo que vendes; la eliges una sola vez desde tu panel. Sobre tus obligaciones fiscales, lo mejor es consultarlo con tu contador.",
    },
    {
        q: "¿Dónde vive mi tienda?",
        a: "En tiendify.io con tu propia dirección, por ejemplo tiendify.io/mi-tienda. Puedes compartir ese enlace en redes sociales, en WhatsApp o donde quieras vender.",
    },
];

export default function Faq() {
    return (
        <section
            id="faq"
            data-testid="home-faq"
            className="py-20 sm:py-28 lg:py-32 bg-white"
        >
            <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary">
                        Preguntas frecuentes
                    </p>
                    <h2 className="mt-4 text-4xl sm:text-5xl font-extrabold tracking-[-0.03em] leading-[1.02] text-[#1A1A1A] text-balance">
                        Lo que casi siempre nos preguntan
                    </h2>
                </div>

                <Accordion type="single" collapsible className="mt-12">
                    {FAQS.map((item, i) => (
                        <AccordionItem key={item.q} value={`faq-${i}`}>
                            <AccordionTrigger className="text-left text-base sm:text-lg font-semibold text-[#1A1A1A] py-5">
                                {item.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[15px] text-[#4A4A4A] leading-relaxed pb-5">
                                {item.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
